import { Text } from "sunrise-ui";

interface errorProps {
  text: string;
}
const ErrorText = ({ text }: errorProps) => {
  return (
    <Text
      type="danger"
      fonts="normal"
      fontSize={14}
      className={`info-text mt0 mr-1 d-flex h-end`}
    >
      {text}
    </Text>
  );
};

export default ErrorText;
